import { render, staticRenderFns } from "./DdCodeTextBoxSwitch.vue?vue&type=template&id=48f45bed&scoped=true&"
import script from "./DdCodeTextBoxSwitch.vue?vue&type=script&lang=js&"
export * from "./DdCodeTextBoxSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DdCodeTextBoxSwitch.vue?vue&type=style&index=0&id=48f45bed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f45bed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VChip,VIcon,VRow,VTextarea})
